import { setReferenceDisplayTransform } from '@seen/core/display'
import { overrideResourceClass } from '@seen/core/ExtendedResource'
import { Participant } from '@seen/core/models/patients/participant'
import { demoReferenceDisplay } from '#src/demo-mode/demoReferenceDisplay.ts'
import { RedactedParticipant } from '#src/demo-mode/RedactedParticipant.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export function isDemoModeStored(): boolean {
  return usePortalStore.getState().demoMode
}

// Call once, before the first FHIR read. A change to demo mode reloads the
// page, so nothing here is undone in place.
export function installDemoModeIfStored(): void {
  if (!isDemoModeStored()) {
    return
  }
  overrideResourceClass(Participant, RedactedParticipant)
  setReferenceDisplayTransform(demoReferenceDisplay)
  document.documentElement.dataset.demoMode = ''
}

export function setDemoModeAndReload(on: boolean): void {
  usePortalStore.getState().setDemoMode(on)
  window.location.reload()
}
